import { baseDatabaseModelType } from "@/propTypes/baseDatabaseModel";
import { arrayOf, bool, exact, number, string } from "prop-types";
import { autoAssignmentRuleType } from "./autoAssignmentRuleType";
import { databaseSystemDefinedPropertiesType } from "./databaseSystemDefinedPropertiesType";
import { userAssignmentRuleType } from "./userAssignmentRuleType";

/** @deprecated use TypeScript interface or type instead */
export const approvalWorkflowType = exact({
  ...databaseSystemDefinedPropertiesType,
  ...baseDatabaseModelType,
  id: string,
  partitionKey: string,
  name: string,
  description: string,
  autoAssignments: arrayOf(autoAssignmentRuleType),
  projectTypeIds: arrayOf(string),
  approvers: arrayOf(
    exact({
      type: number,
      isDeleted: bool,
      name: string.isRequired,
      secondaryId: string.isRequired,
      id: string,
      partitionKey: string,
      _ts: number,
      createdAt: string,
      createdBy: string,
      dependantApprovers: arrayOf(string),
      uniqueIdentifier: string,
      publicId: string,
    })
  ),
  userAssignments: arrayOf(userAssignmentRuleType),
  companyCode: string,
  isDeleted: bool,
  notificationGroups: arrayOf(string),
  publicId: string,
  uniqueIdentifier: string,
});
